import React, { useLayoutEffect } from 'react'
import { useDispatch } from 'react-redux'
import { ScrollableContainer } from 'web/components/generic/ScrollableContainer'
import { Sidebar } from 'web/components/shared/Sidebar'
import { DisplayFightActions, useDisplayState } from 'web/redux/slices/display-fight-slice'
import { useFightSelectors } from 'web/redux/slices/fight-slice'
import { useSetupSelectors } from 'web/redux/slices/setup-slice'
import { sortByDateCreated } from 'web/utils/utils'
import { DisplayFightContainer } from './DisplayFightContainer'
import { DisplayFightSidebar } from './DisplayFightSidebar'

export const DisplayMode: React.FC = () => {

    const displayState = useDisplayState()
    const { getFullFight } = useFightSelectors()
    const { getSetupsForFight } = useSetupSelectors()

    const setups = getSetupsForFight(displayState.selectedFightId)
    const selectedSetup = setups.find(s => s.id === displayState.selectedSetupId)

    const fullFight = getFullFight(displayState.selectedFightId, selectedSetup?.setupFightEvents)

    // We have to do this to initialize the selected setup ID, it's
    // disgusting and I hate it, but I can't think of a smoother way
    // to do it.
    const disp = useDispatch()

    // We want to use layoutEffect here to block painting, otherwise
    // the setup-dropdown will flicker for a frame as we set the setup
    useLayoutEffect(() => {

        if (setups.length >= 1 && displayState.selectedSetupId == null) {
            disp(DisplayFightActions.selectSetup({
                selectedSetupId: sortByDateCreated([...setups], "desc")[0].id
            }))
        }

    }, [disp, setups, displayState.selectedSetupId])

    return (
        <>
            <Sidebar>
                <DisplayFightSidebar
                    fullFight={fullFight}
                    selectedSetup={selectedSetup}
                />
            </Sidebar>

            <ScrollableContainer>
                <DisplayFightContainer
                    fullFight={fullFight}
                    selectedSetup={selectedSetup}
                />
            </ScrollableContainer>
        </>
    )
}
